import React from "react";
import iconTxt from "../../img/icons-ext-file/iconTxt.png"

export default function FileTxt() {
    return (
        <img src={iconTxt} alt="" />
    );
}